import {formatCategory,convertArrayToKeyValue} from '../utils/helpers';
import type { IDataLayer, ISingleItem, ISingleViewItem, CartItem, IItem, IGTMItem, ITrackViewItemListGoldBar, IAddToCartItem, ITrackAddToCartGoldBar,IAddToCartItemPwP, IGTMATCItem} from '~/types/track-item';
import { convertPriceDecimal } from '../utils/formatPrice';
import type {IProductItem} from "~/types/productItem";

interface ITrackRegister {
  first_name: string;
  last_name: string;
  gender: string;
  birthday: Date;
  email: string;
}
function joinValuesWithKey(
  data: { label: string; value: string }[] = [],
  key: string
) {
  return { [key]: data.map(item => item.value).join(',') };
}
export const useCustomGtm = () => {
  const gtm = useGtm()
  const config = useRuntimeConfig();

  const trackCustom = (layers: any) => {
    if( ! gtm ) {
      console.log('trackCustom gtm');
      return;
    }

    if (typeof layers !== 'object') {
      console.log('trackCustom array');
      return;
    }

    try {
      console.log('trackCustom try', layers);
      gtm.push(layers);
    } catch (error) {
      console.error('Error in addWishlist:', error)
    }
  }

  const trackViewItemList = (items: IProductItem[], tax: string) => {
    try {
      if (!Array.isArray(items)) {
        console.error('Items must be an array:', items);
        return;
      }

      if (items.length === 0) {
        console.warn('Items array is empty');
        return;
      }

      gtm.push({
        event: 'ga4_view_item_list',
        ecommerce: {
          currency: 'MYR',
          items: items
          .filter(item => item && typeof item === 'object' && item?.product_id !== undefined)
          .map((item, index) => {
            return {
              item_id: (parseInt(item.product_id) || 0).toString(),
              google_business_vertical: "retail" ,
              item_list_id: tax,
              index,
              item_brand: '',
              ...convertArrayToKeyValue(item.category_labels ?? '[]', 'item_category'),
              item_list_name: 'General Product List',
              item_name: htmlSpecialcharsDecode(item.title) || '',
              sku: item.sku || '',
              product_type: htmlSpecialcharsDecode(item.type) || '',
              price: parseInt(item.sale_price==="" ? item.regular_price : item.sale_price ) || '0.00',
              quantity: '1'
            }
          }),
          value: items.reduce((total, item) => {
            if (item.price !== undefined) {
              return total + parseFloat(item.price);
            }
            return total;
          }, 0)
        },
        fb: {
          content_ids: items.filter(item => item.product_id !== undefined).map(item => parseInt(item.product_id, 10)),
          content_name: items.filter(item => item.title !== '').map(item => item.title),
          content_category: items.filter(item => item.category_labels?.[0] !== undefined).map(item => item.category_labels?.[0]),
          contents: items.map(item => {
            if (item.product_id === undefined) {
              return null;
            }

            return {
              id: item.product_id?.toString() || 'xxx',
              name: item.title,
              item_price: parseFloat(item.price),
              description: `This is a ${item.title} made of ${item.category_labels?.[0] || 'unknown material'}.`,
              categories: item.category_labels?.[0],
              sku: item.sku,
              quantity: "1",
              url: `${config.public.BASE_URL}${item.slug?.replace(/^\//, '')}`
            };
          }).filter(Boolean)
        }
      })
    } catch (error) {
      console.error('Error in trackViewItemList:', error)
    }
  }

  const trackViewCart = (data: Record<string, any>, total: number) => {
    console.log('dataTrackingCart', data);
    try {
      const items: CartItem[] = Object.values(data || {});
      if (!Array.isArray(items)) {

        gtm.push({
          event: 'ga4_view_cart',
          ecommerce: {
            currency: 'MYR',
            items: [],
          },
          value: '0.00',
        });
        return;
      }

      if (items.length === 0) {
        // console.warn('Items array is empty');
        gtm.push({
          event: 'ga4_view_cart',
          ecommerce: {
            currency: 'MYR',
            items: [],
          },
          value: '0.00',
        });
        return;
      }

      gtm.push({
        event: 'ga4_view_cart',
        ecommerce: {
          currency: 'MYR',
          value: parseInt( convertPriceDecimal(total) || '0.00', 10 ),
          items: items.map(item => {
            if (!item || typeof item !== 'object') {
              console.warn('Invalid item:', item);
              return null;
            }

            console.log('item', item.categories);

            const itemPrice = convertPriceDecimal((item.sale_price==="" ? item.regular_price : item.sale_price) ?? "0.00") || '0.00';

            return {
              ...convertArrayToKeyValue(item.categories ?? [], 'item_category'),
              item_id: (item.id || 0).toString(),
              item_name: htmlSpecialcharsDecode(item.title) || '',
              quantity: (item.qty || 0).toString(),
              ...joinValuesWithKey(item?.free_bracele_items ?? [], 'item_variant'),
              sku: item.sku || '',
              // stocklevel: item.max_quantity || 0,
              item_variant: item?.variations ? Object.values(item.variations).join(',') : '',
              price: parseInt(itemPrice, 10),
            };
          }).filter(item => item !== null),
        },
        fb: {
          content_ids: items.filter(item => item.id !== undefined).map(item => item.id),
          content_name: items.filter(item => item.title !== '').map(item => item.title),
          content_category: items.map(item => item.categories),
          contents: items.map(item => {
            if (item.id === undefined) {
              return null;
            }

            const itemPrice = convertPriceDecimal((item.sale_price==="" ? item.regular_price : item.sale_price) ?? "0.00") || '0.00';

            return {
              id: item.id?.toString() || 'xxx',
              name: item.title,
              item_price: itemPrice,
              description: `This is a ${item.title} made of tttt.`,
              categories: 'xxxxx',
              sku: item.sku,
              quantity: "1",
              url: `${config.public.BASE_URL}${item.slug?.replace(/^\//, '')}`
            };
          }).filter(Boolean)
        }
      });

      if (typeof window.lxt != 'undefined') {
        console.warn('Lexer Track', "lxt('track', 'did_start_conversion', true)");
        window.lxt('track', 'did_start_conversion', true);
      }
    } catch (error) {
      console.error('Error in trackViewCart:', error);
    }
  };
  const trackAddToCartByUndo = (items:  CartItem ) => {
    try {
      if (!items) {
        console.error('Invalid items data:', items);
        return;
      }

      const itemName = htmlSpecialcharsDecode(items.title);

      const totalPrice = convertPriceDecimal(items.sale_price==="" ? parseInt(items.regular_price)*items.qty : parseInt(items.regular_price)*items.qty || "0.00") || '0.00';

      gtm.push({
        event: 'ga4_add_to_cart2',
        ecommerce: {
          currency: 'MYR',
          value: parseInt(totalPrice),
          items: [  {
              // google_business_vertical: 'retail',
              item_id: (items.id || 0).toString(),
              // item_brand: '',
              ...convertArrayToKeyValue(items.category ?? [], 'item_category'),
              // item_id: items.id || 0,
              item_name: itemName,
              quantity: items.qty || 0,
              sku: items.sku || '',
              ...joinValuesWithKey(items?.free_bracele_items ?? [], 'item_variant'),
              // stocklevel: 1,
              item_variant: items?.variations ? Object.values(items.variations) : '',
              price: convertPriceDecimal(items.sale_price==="" ? items.regular_price : items.sale_price  || "0.00") || '0.00',
              //stockstatus: "instock",
            }]
        }
      });

      if (typeof window.lxt !== 'undefined') {
        console.warn("lxt('track', 'products_added_to_cart', '" + itemName + "'");
        window.lxt('track', 'products_added_to_cart', itemName);
      }
    } catch (error) {
      console.error('Error in trackViewCart:', error);
    }
  }
  const trackLogin = (userId: string, userName: string, userEmail: string) => {
      if( ! userId && !userEmail  ) {
        return;
      }

      gtm.push({
        event: 'login',
        user_id: userId,
        userEmail: userEmail
      });

      gtm.push({
        event: 'login_ga4',
        user_id: userId,
        userEmail: userEmail
      });

      if (typeof window.lxt != 'undefined') {
        console.warn("lxt('identify', 'email', '" + userEmail + "')");
        window.lxt('identify', 'email', String(userEmail));
      }
  }
  const trackingAddToCartByPwProduct = (items: IAddToCartItemPwP) => {
    try {
      if (!items) {
        console.error('Invalid items data:', items);
        return;
      }

      const itemName = htmlSpecialcharsDecode(items.rule_title);

      gtm.push({
        event: 'ga4_add_to_cart3',
        ecommerce: {
          currency: 'MYR',
          items: [  {
              google_business_vertical: 'retail',
              id: items.product_id || 0,
              item_brand: '',
              item_id: items.product_id || 0,
              rule_id: items.rule_id,
              item_variant: items?.name?.[0] || '',
              item_name: itemName,
              quantity: items.product_qty || 0,
              price: convertPriceDecimal(items?.new_price ? items?.new_price : "0.00") || '0.00',
              stockstatus: "instock",
            }]
        },
        value: convertPriceDecimal(items?.new_price ? items?.new_price : "0.00") || '0.00',
      });

      if (typeof window.lxt !== 'undefined') {
        console.warn("lxt('track', 'products_added_to_cart', '" + itemName + "'");
        window.lxt('track', 'products_added_to_cart', itemName);
      }
    } catch (error) {
      console.error('Error in trackViewCart:', error);
    }
  }
  const trackRegister = (data: ITrackRegister) => {
    if( ! data ) {
      return;
    }

    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };

    const formattedDate = data.birthday.toLocaleDateString('en-US', options);

    gtm.push({
      event: 'register',
      data: {
        first_name: data.first_name,
        last_name: data.last_name,
        gender: data.gender,
        birthday: formattedDate,
        email: data.email,
      }
    });
  }

  const trackPurchased = (data: IDataLayer, newCustomer: boolean = false) => {
    if( ! data.event ) {
      return;
    }

    console.log('trackPurchased', data);

    gtm.push({
      event: 'user_type',
      new_customer: newCustomer
    });

    gtm.push(JSON.parse(JSON.stringify(data)));

    gtm.push({
      event: 'checkout_success',
      email: data.user_data?.email
    });

    if (typeof window.lxt != 'undefined') {
      console.warn("lxt('track', 'did_complete_conversion', true)");
      console.warn("lxt('identify', 'email', '" + data.user_data?.email + "')");
      console.warn("lxt('converted')");

      window.lxt('track', 'did_complete_conversion', true);
      window.lxt('identify', 'email', data.user_data?.email);
      window.lxt('converted');
    }
  }

  const trackAddWishList = (itemName: string) => {
    try {
      if( !itemName ) {
        return;
      }
      gtm.push({
        event: 'add_to_wishlist',
        name: itemName
      })

      if (typeof window.lxt !== 'undefined') {
        console.log('products_added_to_wishlist', itemName);
        window.lxt('track', 'products_added_to_wishlist', itemName);
      }

    } catch (error) {
      console.error('Error in addWishlist:', error)
    }
  }

  const trackRemoveWishList = (itemName: string) => {
    try {
      if( !itemName ) {
        return;
      }
      gtm.push({
        event: 'remove_from_wishlist',
        name: itemName
      })

      if (typeof window.lxt !== 'undefined') {
        console.log('products_removed_from_wishlist', itemName);
        window.lxt('track', 'products_removed_from_wishlist', itemName);
      }

    } catch (error) {
      console.error('Error in removeWishList:', error)
    }
  }

  const trackRegistration = () => {
    if( ! gtm ) {
      return;
    }

    try {
      gtm.push({
        event: 'registration'
      })
    } catch (error) {
      console.error('Error in removeWishList:', error)
    }
  }

  const trackRemoveCartFrom = (itemName: any) => {
    try {

      if( !itemName ) {
        return;
      }

      console.log('trackRemoveCartFrom', itemName);

      gtm.push(itemName)

      if (typeof window.lxt != 'undefined') {
        console.warn("lxt('track', 'products_removed_from_cart', '" + itemName + "')");
        window.lxt('track', 'products_removed_from_cart', itemName);
      }
    } catch (error) {
      console.error('Error in removeItemCartFrom:', error)
    }
  }

    // const trackViewItemListGoldBar = (items: any) => {
    //     console.log(items)
    //     if (items && Array.isArray(items.variation) && items.variation.length > 0) {
    //         const variation = items.variation[0]
    //         try {
    //             gtm.push({
    //                 event: 'view_item_list',
    //                 ecommerce: {
    //                     currency: 'MYR',
    //                     items: [
    //                         {
    //                             "internal_id": parseInt(items.id) || 0,
    //                             "item_id": parseInt(variation.id) || 0,
    //                             "item_name": items.title || '',
    //                             "sku": items.sku || '',
    //                             "price": (variation.regularPrice || 0).toString(),
    //                             "stocklevel": null,
    //                             "stockstatus": variation.isInStock ? 'instock' : 'outstock',
    //                             "google_business_vertical": "retail",
    //                             "item_category": "Uncategorized",
    //                             "id": parseInt(variation.id) || 0,
    //                             "item_brand": "",
    //                             "variant": variation.slug || "2g"
    //                         }
    //                     ],
    //                     value: (variation.regularPrice || 0).toString(),
    //                 }
    //             })
    //         } catch (error) {
    //             console.error('Error in View Item List GoldBar:', error)
    //         }
    //     }else {
    //         return;
    //     }

    // }

    const trackViewItemListGoldBar = (items: IItem) => {
        if (items && Array.isArray(items.variation) && items.variation.length > 0) {
            const variation = items.variation[0];

            try {
                const gtmItem: IGTMItem = {
                    internal_id: parseInt(items.id) || 0,
                    item_id: parseInt(variation.id) || 0,
                    item_name: items.title || '',
                    sku: '',
                    price: String(convertPriceDecimal(variation.regularPrice) || 0),
                    stocklevel: null,
                    stockstatus: variation.isInStock ? 'instock' : 'outstock',
                    google_business_vertical: "retail",
                    item_category: "Uncategorized",
                    id: parseInt(variation.id) || 0,
                    item_brand: "",
                    variant: variation.slug || "2g",
                };

                const gtmData: ITrackViewItemListGoldBar = {
                    event: 'view_item_list',
                    ecommerce: {
                        currency: 'MYR',
                        items: [gtmItem],
                        value: String(convertPriceDecimal(variation.regularPrice) || 0),
                    },
                };

                gtm.push(gtmData);
            } catch (error) {
                console.error('Error in View Item List GoldBar:', error);
            }
        } else {
            return;
        }
    };

    const trackAddToCartGoldBar = (items: IAddToCartItem) => {
        console.log('items atc', items)
        try {
            if (!items) {
                console.error('Invalid items data:', items);
                return;
            }

            const gtmItem: IGTMATCItem = {
                internal_id: parseInt(items.variation_id.toString()) || 0,
                item_id: parseInt(items.product_id.toString()) || 0,
                item_name: items.customTitle || '',
                sku: items.sku || '',
                price: String(convertPriceDecimal(items.price_gtm) || 0),
                stocklevel: null,
                stockstatus: 'instock',
                google_business_vertical: "retail",
                item_category: "Uncategorized",
                id: parseInt(items.product_id.toString()) || 0,
                item_brand: "",
                variant: items.weightAttr || "2g",
                quantity: '1',
            };

            const gtmData: ITrackAddToCartGoldBar = {
                event: 'add_to_cart',
                ecommerce: {
                    currency: 'MYR',
                    items: [gtmItem],
                    value: String(convertPriceDecimal(items.price_gtm) || 0),
                },
            };

            gtm.push(gtmData);
        } catch (error) {
            console.error('Error in Add To Cart GoldBar:', error);
        }
    };



    // const trackAddToCartGoldBar = (items: any) => {
    //     try {
    //         if (!items) {
    //             console.error('Invalid items data:', items);
    //             return;
    //         }
    //         gtm.push({
    //         event: 'add_to_cart',
    //         ecommerce: {
    //             currency: 'MYR',
    //             items: [
    //                 {
    //                     "internal_id": items.variation_id || 0,
    //                     "item_id": items.product_id || 0,
    //                     "item_name": items.customTitle || '',
    //                     "sku": items.sku || '',
    //                     "price":  (items.price_gtm || 0).toString() || '',
    //                     "stocklevel": null,
    //                     "stockstatus": 'instock',
    //                     "google_business_vertical": "retail",
    //                     "item_category": "Uncategorized",
    //                     "id": items.product_id || 0,
    //                     "item_brand": "",
    //                     "variant": items.weightAttr || "2g",
    //                     "quantity" : '1'
    //                 }
    //             ],
    //             value: (items.price_gtm || 0).toString(),
    //         }
    //     })
    //     } catch (error) {
    //         console.error('Error in Add To Cart GoldBar:', error)
    //     }
    // }

    const pushToDataLayer = (event: string, additionalData: Record<string, any> = {}) => {
      try {
          const eventData = {
              event,
              ...additionalData, // Merge any additional data passed
          };

          gtm.push(eventData);
          console.log(`Event "${event}" pushed to dataLayer`, eventData);
      } catch (error) {
          console.error(`Error pushing event "${event}" to dataLayer:`, error);
      }
  };

  const pushPageTypeToDataLayer = (
      pageType: string,
      hierarchy: { hierachy1?: string; hierachy2?: string; hierachy3?: string } = {
          hierachy1: 'n/a',
          hierachy2: 'n/a',
          hierachy3: 'n/a',
      }
  ) => {
      try {
          const pageData = {
              pageType,
              ...hierarchy,
          };

          gtm.push(pageData);
          console.log(`PageType "${pageType}" with hierarchy pushed to dataLayer`, pageData);
      } catch (error) {
          console.error(`Error pushing pageType "${pageType}" to dataLayer:`, error);
      }
  };
  // Single Product Event
  const singleViewItemEvent = (item: ISingleItem) => {
    try {
      const itemDetails: any = {
        event: 'view_item',
        ecommerce: {
          currency: "MYR",
          items: [{
            item_name: htmlSpecialcharsDecode(item.item_name),
            item_id: item.item_id,
            price: convertPriceDecimal(item.price),
            item_brand: '',
            sku: item.sku,
            google_business_vertical: "retail",
            stockstatus: item.stockstatus,
            quantity: (item.stocklevel || '').toString(),
            id: item.id
          }],
          value: parseInt(convertPriceDecimal(item.price), 10),
        }
      }

      if (item.variant) {
        itemDetails.ecommerce.items[0].variant = item.variant
      }
      if (item.internal_id) {
        itemDetails.ecommerce.items[0].internal_id = item.internal_id;
      }
      if (item.item_category) {
        itemDetails.ecommerce.items[0].item_category = htmlSpecialcharsDecode(item.item_category);
      }
      if (item.item_category2) {
        itemDetails.ecommerce.items[0].item_category2 = htmlSpecialcharsDecode(item.item_category2);
      }
      if (item.item_category3) {
        itemDetails.ecommerce.items[0].item_category3 = htmlSpecialcharsDecode(item.item_category3);
      }
      if (item.item_category4) {
        itemDetails.ecommerce.items[0].item_category4 = htmlSpecialcharsDecode(item.item_category4);
      }
      if (item.item_category5) {
        itemDetails.ecommerce.items[0].item_category5 = htmlSpecialcharsDecode(item.item_category5);
      }

      gtm?.push(itemDetails);
    } catch (error) {
      console.error(`Error view_item PDP`, error);
    }
  }
  const singleViewItemListEventTracking = (items: any, listingName: string) => {
    try {
      if (!Array.isArray(items)) {
        console.error('Items must be an array:', items)
        return;
      }
      if (items.length === 0) {
        console.warn('Items array is empty')
        return
      }
      gtm?.push({
        event: 'view_item_list',
        ecommerce: {
          currency: 'MYR',
          items: items.map((item, index) => {
            if (!item || typeof item !== 'object') {
              console.warn('Invalid item:', item)
              return null
            }

            return {
              item_id: parseInt(item.id) || 0,
              id: parseInt(item.id) || 0,
              index: index+2,
              item_brand:'',
              ...convertArrayToKeyValue(JSON.parse(item.category_label) ?? '[]', 'item_category'),
              item_list_name: listingName,
              item_name: htmlSpecialcharsDecode(item.title) || '',
              sku: item.sku || '',
              product_type: htmlSpecialcharsDecode(item.type) || '',
              stocklevel: item.stock_level || null,
              price: item.price || "",
              stockstatus: item.stock_status || ''
            }
          }).filter(item => item !== null)
        }
      })
    } catch (error) {
      console.error('Error in trackViewItemList:', error)
    }
  }
  const singleAddToCartEventTracking = (item: ISingleItem) => {
    console.log('item', item);
    try {
      const itemDetails: any = {
        event: 'ga4_add_to_cart',
        ecommerce: {
          currency: "MYR",
          items: [{
            item_name: item.item_name,
            item_id: (item.item_id || '').toString(),
            google_business_vertical: "retail",
            price: parseInt(convertPriceDecimal(item.price), 10),
            item_category: item.item_category,
            ...(item.item_category2 ? { item_category2: item.item_category2 } : {}),
            ...(item.item_category3 ? { item_category3: item.item_category3 } : {}),
            ...(item.item_category4 ? { item_category4: item.item_category4 } : {}),
            ...(item.item_category5 ? { item_category5: item.item_category5 } : {}),
            sku: item.sku,
            quantity: item.stocklevel || '1'
          }],
          value: parseInt(convertPriceDecimal(item.price), 10),
        },
        fb: {
          content_ids: (item.item_id || '').toString(),
          content_name: [item.item_name],
          content_category: [
            item.item_category,
            item.item_category2,
            item.item_category3,
            item.item_category4,
            item.item_category5
          ].filter(Boolean),
          contents: {
            id: (item.item_id || '').toString(),
            name: item.item_name,
            item_price: parseInt(item.price, 10),
            description: item.description,
            categories: item.item_category,
            sku: item.sku,
            quantity: "1",
            url: `${config.public.BASE_URL}${item.slug?.replace(/^\//, '')}`
          }
        }
      }

      if (item.variant) {
        itemDetails.ecommerce.items[0].variant = item.variant
      }
      // if (item.internal_id) {
      //   itemDetails.ecommerce.items[0].internal_id = item.internal_id
      // }
      gtm.push(itemDetails);
    } catch (error) {
      console.error(`Error add_to_cart GA PDP`, error);
    }
  }
  const singleAddWishListEventTracking = (items: string) => {
    try {
      gtm?.push({
        event: 'add_to_wishlist',
        name: items ?? ''
      })

    } catch (error) {
      console.error('Error in addWishlist:', error)
    }
  }
  const singleRemoveWishListTracking = (items: string) => {
    try {
      gtm?.push({
        event: 'remove_from_wishlist',
        name: items ?? ''
      })

    } catch (error) {
      console.error('Error in removeWishList:', error)
    }
  }

  return {
    trackCustom,
    trackRegistration,
    trackViewItemList,
    trackViewCart,
    trackAddToCartByUndo,
    trackLogin,
    trackRegister,
    trackPurchased,
    trackAddWishList,
    trackRemoveWishList,
    trackRemoveCartFrom,
    trackViewItemListGoldBar,
    trackAddToCartGoldBar,
    trackingAddToCartByPwProduct,
    pushToDataLayer,
    pushPageTypeToDataLayer,
    singleViewItemEvent,
    singleViewItemListEventTracking,
    singleAddToCartEventTracking,
    singleAddWishListEventTracking,
    singleRemoveWishListTracking
  }
}